
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/netsuite-rest",
      function () {
        return require("private-next-pages/destinations/netsuite-rest.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/netsuite-rest"])
      });
    }
  